module.exports = __webpack_public_path__ + "static/img/cooperation_4.3f08812.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/cooperation_4.png
// module id = rHcH
// module chunks = 1